import React from 'react';
import {
  SendToolbarProps,
  SearchTypeToggle,
  SearchInput,
  SetFilter,
  PriceFilter,
  AutoMatchControl,
  DensityDropdown,
  DownloadButton,
  DEFAULT_DISPLAY_MODE,
  DEFAULT_SORT_VALUE,
} from './sendToolbarControls';
import SendSortDropdown from './SendSortDropdown';
import { CollapseAllButton } from 'components/TraderListCollapse/TraderListCollapse';

/**
 * Mobile (<768px) toolbar: vertical stack matching the prod layout.
 * 5 rows, all controls visible — no overflow menu.
 */
export default function MobileSendToolbar(props: SendToolbarProps) {
  const {
    onSearch,
    displayMode = DEFAULT_DISPLAY_MODE,
    onDisplayModeChange,
    initialSearchValue = '',
    searchType = 'card',
    onSearchTypeChange,
    globalAutoMatch = false,
    onGlobalAutoMatchToggle,
    matchSummary,
    isMatchIndexLoading = false,
    hasMatchIndexError = false,
    onRetryMatchIndex,
    priceMin,
    priceMax,
    onPriceMinChange,
    onPriceMaxChange,
    sortValue = DEFAULT_SORT_VALUE,
    onSortChange,
    isSortLoading = false,
    onExportCsv,
    isExporting = false,
    hasResults = false,
    selectedSets = [],
    onSelectedSetsChange,
    collapseAll = false,
    onCollapseAllToggle,
  } = props;

  return (
    <div className="send-toolbar-mobile">
      {/* Row 1 — Auto-Match with its label always visible; Collapse all at the right */}
      <div className="send-toolbar-mobile-row send-toolbar-mobile-row-automatch">
        <AutoMatchControl
          globalAutoMatch={globalAutoMatch}
          onGlobalAutoMatchToggle={onGlobalAutoMatchToggle}
          matchSummary={matchSummary}
          isMatchIndexLoading={isMatchIndexLoading}
          hasMatchIndexError={hasMatchIndexError}
          onRetryMatchIndex={onRetryMatchIndex}
          showSummary
        />
        {onCollapseAllToggle && (
          <CollapseAllButton
            collapseAll={collapseAll}
            onToggle={onCollapseAllToggle}
            className="trader-collapse-all--send-mobile"
          />
        )}
      </div>

      {/* Row 2 — Card/Trader toggle attached to search input */}
      <div className="send-toolbar-mobile-row send-toolbar-mobile-row-search">
        <SearchTypeToggle
          searchType={searchType}
          onSearchTypeChange={onSearchTypeChange}
          attached
        />
        <SearchInput
          searchType={searchType}
          initialSearchValue={initialSearchValue}
          onSearch={onSearch}
          attached
        />
      </div>

      {/* Row 3 — SET filter */}
      {onSelectedSetsChange && (
        <div className="send-toolbar-mobile-row send-toolbar-mobile-row-set">
          <SetFilter
            selectedSets={selectedSets}
            onSelectedSetsChange={onSelectedSetsChange}
          />
        </div>
      )}

      {/* Row 4 — Price Min + Price Max */}
      <div className="send-toolbar-mobile-row send-toolbar-mobile-row-price">
        <PriceFilter
          priceMin={priceMin}
          priceMax={priceMax}
          onPriceMinChange={onPriceMinChange}
          onPriceMaxChange={onPriceMaxChange}
        />
      </div>

      {/* Row 5 — Sort + Density + Download */}
      <div className="send-toolbar-mobile-row send-toolbar-mobile-row-bottom">
        <SendSortDropdown
          sortValue={sortValue}
          onSortChange={onSortChange}
          isSortLoading={isSortLoading}
        />
        <DensityDropdown
          displayMode={displayMode}
          onDisplayModeChange={onDisplayModeChange}
        />
        <DownloadButton
          onExportCsv={onExportCsv}
          isExporting={isExporting}
          hasResults={hasResults}
        />
      </div>
    </div>
  );
}
